import React from "react";
import { ArrowLeft, ArrowRight } from "react-feather";
import { FaUserInjured, FaHandHoldingHeart } from "react-icons/fa";
const MatchCardComponent = ({
  title,
  person,
  bgColor,
  textColor,
  code,
  consultant,
  person_type,
}) => {
  return (
    <div className={`${bgColor} rounded-lg p-4 shadow-md w-full md:w-5/12 `}>
      <div className="flex items-center mb-4 ">
        <div
          className={`p-3 rounded-full ${
            person_type === "R"
              ? "bg-white border border-indigo-800"
              : "bg-white border border-green-800"
          } mr-4 `}
        >
          {person_type === "R" ? (
            <FaUserInjured className="w-8 h-8 text-indigo-500" />
          ) : (
            <FaHandHoldingHeart className="w-8 h-8 text-green-500" />
          )}
        </div>
        <h3 className={`text-lg font-semibold ${textColor}`}>{title}</h3>
      </div>
      <div className="space-y-2">
        <InfoItem label="Name" value={getFullName(person)} />
        <InfoItem label="Code" value={code} />
        <InfoItem label="Blood Group" value={getBloodGroup(person)} />
        <InfoItem label="Gender" value={getGender(person)} />
        <InfoItem label="Consultant" value={getConsultantName(consultant)} />
      </div>
    </div>
  );
};

export const ArrowIndicator = () => (
  <div className="flex items-center justify-center py-2 md:py-0">
    <ArrowLeft className="mr-1 text-indigo-500" size={20} />
    <ArrowRight className="ml-1 text-indigo-500" size={20} />
  </div>
);

const InfoItem = ({ label, value }) => (
  <p className="flex justify-between text-sm">
    <span className="font-medium">{label}:</span>
    <span className="text-gray-700">{value}</span>
  </p>
);

const getFullName = (person) => {
  if (!person) return "N/A";
  if (person.name) return person.name;
  const name = `${person.member_title || ""} ${
    person.donor_name || person.recipient_name || ""
  } ${person.last_name || ""}`.trim();
  return name || "N/A";
};

const getBloodGroup = (person) => {
  if (!person) return "N/A";
  return person.bloodgroup || person.blood_group?.label || "N/A";
};

const getGender = (person) => {
  if (!person) return "N/A";
  return person.gender_label || person.gender?.label || "N/A";
};

const getConsultantName = (consultant) => {
  if (!consultant) return "N/A";
  // If populated, consultant is an object with name fields
  if (typeof consultant === "object") {
    const name = consultant.name ||
      `${consultant.first_name || ""} ${consultant.last_name || ""}`.trim() ||
      consultant.email ||
      null;
    if (name) return name;
  }
  // If it's a string and looks like a MongoDB ObjectId (24 hex chars), don't show it
  if (typeof consultant === "string" && /^[a-f0-9]{24}$/i.test(consultant)) {
    return "N/A";
  }
  return String(consultant);
};

export default MatchCardComponent;
